(function () {
  document.addEventListener('DOMContentLoaded', init);

  function init() {
    const root = document.querySelector('[data-bundle-builder]');
    if (!root) return;

    const threshold = parseFloat(root.dataset.threshold || '500');
    const discountPercent = parseFloat(root.dataset.discountPercent || '10');

    const items = Array.from(root.querySelectorAll('[data-bundle-item]'));
    const summaryList = root.querySelector('[data-bundle-summary-list]');
    const emptyMessage = root.querySelector('[data-bundle-empty-message]');
    const countEl = root.querySelector('[data-bundle-count]');
    const subtotalEl = root.querySelector('[data-bundle-subtotal]');
    const discountNote = root.querySelector('[data-bundle-discount-note]');
    const progressWrap = root.querySelector('[data-bundle-progress-wrap]');
    const progressFill = root.querySelector('[data-bundle-progress-fill]');
    const progressText = root.querySelector('[data-bundle-progress-text]');
    const addToCartBtn = root.querySelector('[data-bundle-add-to-cart]');

    // Map of variantId -> { title, price, qty }
    const selected = new Map();

    items.forEach((item) => {
      const button = item.querySelector('[data-bundle-add]');
      button.addEventListener('click', () => toggleItem(item));
    });

    addToCartBtn.addEventListener('click', addBundleToCart);

    function toggleItem(item) {
      const variantId = item.dataset.variantId;
      const price = parseFloat(item.dataset.price);
      const title = item.dataset.title;
      const label = item.querySelector('[data-add-label]');

      if (selected.has(variantId)) {
        selected.delete(variantId);
        item.classList.remove('is-selected');
        label.textContent = '+ Add';
      } else {
        selected.set(variantId, { title, price, qty: 1 });
        item.classList.add('is-selected');
        label.textContent = '✓ Added';
      }
      render();
    }

    function removeItem(variantId) {
      selected.delete(variantId);
      items.forEach((el) => {
        if (el.dataset.variantId === variantId) {
          el.classList.remove('is-selected');
          el.querySelector('[data-add-label]').textContent = '+ Add';
        }
      });
      render();
    }

    function resetSelection() {
      selected.clear();
      items.forEach((el) => {
        el.classList.remove('is-selected');
        el.querySelector('[data-add-label]').textContent = '+ Add';
      });
      render();
    }

    function render() {
      const count = selected.size;
      let subtotal = 0;
      selected.forEach((entry) => (subtotal += entry.price * entry.qty));

      emptyMessage.style.display = count ? 'none' : 'block';

      summaryList.querySelectorAll('.bundle-summary__row').forEach((row) => row.remove());
      selected.forEach((entry, variantId) => {
        const row = document.createElement('div');
        row.className = 'bundle-summary__row';
        row.innerHTML =
          '<span>' + entry.title + '</span>' +
          '<span>$' + entry.price.toFixed(2) + ' <button type="button" aria-label="Remove">&times;</button></span>';
        row.querySelector('button').addEventListener('click', () => removeItem(variantId));
        summaryList.appendChild(row);
      });

      countEl.textContent = 'Selected Items: ' + count;
      subtotalEl.textContent = 'Subtotal: $' + subtotal.toFixed(2);

      const qualifies = subtotal >= threshold;
      discountNote.hidden = !qualifies;

      if (count > 0) {
        progressWrap.hidden = false;
        const pct = Math.min(100, (subtotal / threshold) * 100);
        progressFill.style.width = pct + '%';
        progressText.textContent = qualifies
          ? 'You unlocked ' + discountPercent + '% off!'
          : 'Add $' + (threshold - subtotal).toFixed(2) + ' more to unlock ' + discountPercent + '% off';
      } else {
        progressWrap.hidden = true;
      }

      addToCartBtn.disabled = count === 0;
    }

    function showToast(message) {
      const toast = document.createElement('div');
      toast.className = 'bundle-toast';
      toast.textContent = message;
      document.body.appendChild(toast);
      requestAnimationFrame(() => toast.classList.add('show'));
      setTimeout(() => {
        toast.classList.remove('show');
        setTimeout(() => toast.remove(), 300);
      }, 2500);
    }

    function openCartDrawerIfPresent() {
      // Dawn theme's <cart-drawer> custom element, when present, exposes an open() method
      const drawer = document.querySelector('cart-drawer');
      if (drawer && typeof drawer.open === 'function') {
        drawer.open();
        return true;
      }
      return false;
    }

    async function addBundleToCart() {
      if (!selected.size) return;

      addToCartBtn.disabled = true;
      const originalText = addToCartBtn.textContent;
      addToCartBtn.textContent = 'Adding...';

      const itemsPayload = Array.from(selected.entries()).map(([variantId, entry]) => ({
        id: variantId,
        quantity: entry.qty,
      }));

      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: itemsPayload }),
        });

        if (!response.ok) {
          const err = await response.json();
          throw new Error(err.description || 'Could not add bundle to cart');
        }

        // Notify Dawn's cart drawer / cart icon bubble to refresh, if present
        document.dispatchEvent(new CustomEvent('cart:refresh'));

        const opened = openCartDrawerIfPresent();
        if (!opened) {
          showToast('Bundle added to cart!');
        }

        resetSelection();
      } catch (error) {
        console.error(error);
        showToast(error.message || 'Something went wrong adding your bundle to the cart.');
      } finally {
        addToCartBtn.textContent = originalText;
        // addToCartBtn.disabled stays controlled by render(), which resetSelection() already called
      }
    }

    render();
  }
})();